import { useIsMobile } from '@/hooks/use-mobile';

const CHART_HEIGHT_CLASSES = {
    sm: { mobile: 'h-[200px]', desktop: 'h-[260px]' },
    md: { mobile: 'h-[220px]', desktop: 'h-[300px]' },
    lg: { mobile: 'h-[240px]', desktop: 'h-[360px]' },
} as const;

export type ChartHeightSize = keyof typeof CHART_HEIGHT_CLASSES;

export function useChartHeightClass(size: ChartHeightSize = 'md'): string {
    const isMobile = useIsMobile();
    return isMobile ? CHART_HEIGHT_CLASSES[size].mobile : CHART_HEIGHT_CLASSES[size].desktop;
}
